$(() => {
    initFunctions();
});

function initFunctions() {
    initCheckQuickorderUrl();
    initAddAllButton();
    // initAutoFillShoppingcart();
    initChangePasswordWatcher();
    initConfirmButtonClick();
    initCompanyLookupFormWatcher();
    initCustomDropdownWatcher();
    initCustomTransportDropdown();
    initNextProductAmountItem();
    initSearchTableList();
    initTableHeight();
    initTempCountryWatch();
    initWatchOnlyNumberInput();
    initAvailableCodesWatcher();
    initEbCounter();
    initDiscountInputWatch();
    filledInFirstRegisterForm();

    // initTest();
}

function initCheckQuickorderUrl() {
    let c = new URLSearchParams(window.location.search);
    if (c.has('quickorder')) {
        $('[data-target="#importmodal"]').trigger('click');
    }
}

function getNonEmptyFields(fields) {
    let r = [];
    $.each(fields, function() {
        if ($(this).val() === '')
            return;
        
        r.push($(this));
    });

    return r;
}

function initAddAllButton() {
    let button = $('#addAllToCartButton');
    if (!button[0])
        return;
    
    button.on('click', function() {
        let amountFields = $('.fastAmount');
        let fields = getNonEmptyFields(amountFields);
        
        $.each(fields, function() {
            let row = $('.producttable tbody > tr:nth-of-type(' + getNumbers($(this)[0].id) + ')');
            row.find('.fastsubmitbutton').trigger('click');
        });
    })
}

function getNumbers(c) {
    return parseInt(c.replace(/[^0-9]/gi, ''));
}

function initNextProductAmountItem() {
    let amountFields = $('.fastAmount');
    if (!amountFields[0])
        return;

    let i = 1;
    $.each(amountFields, function() {
        $(this)[0].id = 'amount-' + i++;
    });
    
    amountFields.on('keydown', function(e) {
        if (e.key !== 'Tab')
            return;
        e.preventDefault();

        let id = e.target.id;
        next = getNumbers(id) + 1;
        if (next > amountFields.length)
            next = 1;
        $('.fastAmount#amount-' + next).focus();
    });
    
    amountFields.on('change', function() {
        let nonEmptyFields = getNonEmptyFields(amountFields);
        nonEmptyFields.length > 1 ? $('.addAllToCartButtonWrapper').removeClass('hide') : $('.addAllToCartButtonWrapper').addClass('hide');
    });
}

function initSearchTableList() {
    let c = $('#searchfilter');

    if (!c[0])
        return;
    
    let mainFilters = c.find('.searchCategoryFilter');
    
    $.each(mainFilters, function() {
        let c = $(this);
        let subcat = $('#' + c[0].id + ' .subcategories');
        subcat.css('height', (subcat.height() + 4) + 'px');
        c.addClass('initialized');
    });
    
    mainFilters.on('click', function(e) {
        if (e.target.id === undefined || e.target.id === '')
            return;

        let target = $('#' + e.target.id);
        if (!target.hasClass('searchCategoryFilter'))
            return;

        if (target.hasClass('openSubcats')) {
            target.removeClass('openSubcats');
            return;
        }

        $('.searchCategoryFilter').removeClass('openSubcats');
        target.addClass('openSubcats');
    });
}

function setTableHeight(table, resize = false) {
    let labels = table.find('thead tr th');
    let fields = table.find('td, th');
    let highestField = 0;
    if (resize) {
        $.each(fields, function () {
            $(this).css('height', 'unset');
        });
    }

    $.each(labels, function () {
        let c = $(this);
        let height = c.height() + parseInt(c.css('padding-top')) + parseInt(c.css('padding-bottom'));
        if (height > highestField)
            highestField = height;
    });

    $.each(fields, function () {
        $(this).css('height', highestField + 'px');
    });
}

function initTableHeight() {
    let table = $('#test-products-responsive');

    if (!table[0])
        return;

    setTableHeight(table);
    $(window).on('resize', function () {
        setTableHeight(table, true);
    });
}

function initTempCountryWatch() {
    let field = $('#tempCountry');
    if (!field[0])
        return;

    $('#submitbutton').on('click', function(e) {
        e.preventDefault();
    });
    
    field.on('change', function() {
        let val = field.val();
        let newFields = getRequiredFields(val);
        let form = $('.md-form');
        form.find('#tempCountry').closest('.field').addClass('hide');
        $.each(newFields, function(index, fieldId) {
            let cfield = form.find('#registration_form_' + fieldId);
            cfield.closest('.field').removeClass('hide');
        });
    })
}

function getRequiredFields(val) {
    if (val === 'nl')
        return ['zipcode', 'streetnumber'];

    return getAllFields();
}

function getAllFields() {
    return [/*'country', */'kvknummer', 'btwnummer', 'company_name', 'zipcode', 'streetname', 'streetnumber', 'city', 'company_phonenumber', 'fax', 'firstname', 'lastname', 'email', 'contact_phonenumber', 'plainPassword', 'confirmPassword'];
}

function searchCustomDropdown(val) {
    val = val.toLowerCase();
    let fields = $('.custom-dropdown-option');
    $.each(fields, function() {
        let c = $(this);
        let cVal = c[0].innerText.toLowerCase();
        if (cVal.indexOf(val) < 0) {
            c.addClass('hide');
            return;
        }

        c.removeClass('hide');
    });
}

function changeCustomer(id) {
    let baseUri = window.location.protocol + "//" + window.location.host + basePath;

    let apiRequests = new ApiRequestsEmployeeUser();
    apiRequests.ChangeOrderFor(customerId, baseUri, id, function () { 
        window.location.reload();
    });
}

function initCustomDropdownWatcher() {
    let customDropdown = $('.custom-dropdown');
    if (!customDropdown[0])
        return;

    customDropdown.on('click', function(e) {
        let c = e.target;
        if ($.inArray('custom-dropdown-option', c.classList) == -1)
            return;

        changeCustomer(c.id);
    });

    let inputField = $('#customDropdownSearch');
    inputField.on('keydown', function(e) {
        if (e.key !== 'Enter')
            return;

        e.preventDefault();
        searchCustomDropdown(inputField.val());
    });
}

function initChangePasswordWatcher() {
    let passwordForm = $('form[name="change_password"]');
    if (!passwordForm[0])
        return;
    
    passwordForm.submit(function(e) {
        let pass = $('#change_password_password');
        let confirm = $('#change_password_confirm_password');

        pass.val().length < 6 ? pass.addClass('error') : pass.removeClass('error');
        confirm.val().length < 6 ? confirm.addClass('error') : confirm.removeClass('error');
        
        if (pass.hasClass('error') || confirm.hasClass('error'))
            e.preventDefault();
    });
}

function initCustomTransportDropdown() {
    let valueField = $('.custom-transportmethods-dropdown-value');
    let openclass = 'open';
    let dropdown = $('.custom-transportmethods-dropdown');
    let options = $('.custom-transportmethods-dropdown-option');
    
    valueField.on('click', function() {
        dropdown.hasClass(openclass) ? dropdown.removeClass(openclass) : dropdown.addClass(openclass);
    });

    options.on('click', function(e) {
        let selectedOption = $('#' + e.target.id);
        let name = selectedOption.find('span:first-of-type').text();
        let price = selectedOption.find('span:last-of-type').text();
        valueField.html(`<span>${name}</span><span>${price}</span>`);
        dropdown.removeClass(openclass);
        $('[name="sbTrans"]').val(e.target.id).trigger('change');
        checkTransportCostsAndApplyPriceUpdate(document.querySelector("[name='sbTrans']").selectedIndex);
    });
}

function initWatchOnlyNumberInput() {
    let field = $('#create_transport_location_streetnumber');
    if (!field[0])
        return;

    field.on('keydown', function(e) {
        let regex = /[0-9]|\./;
        if (!regex.test(e.key) && e.key !== 'Tab')
            e.preventDefault();
    });
}

function initConfirmButtonClick() {
    let confirmButtons = $('.btn-confirm-click');
    
    if (!confirmButtons[0])
        return;
    
    confirmButtons.on('click', function(e) {
        if (!confirm("Weet je het zeker?"))
            e.preventDefault();
    });
}

function initCompanyLookupFormWatcher() {
    let button = $('#lookupButton');
    if (!button[0])
        return;

    button.on('click', function(e) {
        e.preventDefault();

        // @TODO implement kvk search api
        // @TODO move function
        
        $('.companyLookupForm').addClass('hide');
        $('.md-form > .field.hide:not(.keep-hidden)').removeClass('hide');
    });
}

function filledInFirstRegisterForm() {
    let nextButton = $('#nextbutton');
    if (!nextButton[0])
        return;

    nextButton.on('click', function(e) {
        e.preventDefault();
        
        let isValid = true;

        $('.md-form > .field:not(.hide)').each(function() {
            let input = $(this).find('input, select, textarea');
            let fieldName = input.attr('name'); // Get the field name for custom validation
            
            // Clear any previous error messages
            $(this).find('.alert').remove();

            // Check if the field is required and not filled
            if (input.prop('required') && !input.val()) {
                isValid = false;
                $(this).append('<div class="alert alert-danger mt-2">This field is required</div>');
            } else {
                // Custom validation for specific fields
                if (fieldName.includes('kvknummer')) {
                    if (!/^\d{8}$/.test(input.val())) {
                        isValid = false;
                        $(this).append('<div class="alert alert-danger mt-2">KVK number must be exactly 8 digits</div>');
                    }
                }
        
                if (fieldName.includes('btwnummer')) {
                    const value = input.val().trim();
                    const vatRegex = /^[A-Z]{2}[A-Z0-9]{2,}$/i;

                    if (!vatRegex.test(value)) {
                        isValid = false;
                        $(this).append('<div class="alert alert-danger mt-2">Enter a valid VAT number (e.g. NL123456789B01)</div>');
                    }
                }

                if (fieldName.includes('zipcode')) {
                    if (!/^\d{4}[A-Za-z]{2}$/.test(input.val())) {
                        isValid = false;
                        $(this).append('<div class="alert alert-danger mt-2">Zipcode must be exactly 6 characters long (4 digits followed by 2 letters)</div>');
                    }
                }

                if (fieldName.includes('streetnumber')) {
                    if (!/^\d+$/.test(input.val())) {
                        isValid = false;
                        $(this).append('<div class="alert alert-danger mt-2">Street number must contain only numbers</div>');
                    }
                }

                if (fieldName.includes('company_phonenumber')) {
                    if (!/^\d+$/.test(input.val())) {
                        isValid = false;
                        $(this).append('<div class="alert alert-danger mt-2">Company phonenumber must contain only numbers</div>');
                    }
                } 
            }
        });

        // If all fields are valid, proceed to the next step
        if (isValid) {
            $('.md-form > .field:not(.hide)').addClass('hide');
            $('.md-form > .field2.hide:not(.keep-hidden)').removeClass('hide');
            $('#nextbutton').addClass('hide');
            $('#submitbutton').removeClass('hide');
        }
    });
}

function initAutoFillShoppingcart() {
    let input = $('#verifyDiscountInput');
    let btn = $('#verifyDiscountButton');
    if (!input[0] || !btn[0])
        return;

    input.val('test');
    btn.trigger('click');

    input.val('test1234566');
    btn.trigger('click');
    
    input.val('test567');
    btn.trigger('click');

    input.val('');

    $('[name="sbTrans"]').val('pickup');
    $('[name="cbterms"]').trigger('click');

    $('#submitShoppingCartButton').trigger('click');
}

function initAvailableCodesWatcher() {
    let discountList = $('#availableCodes .discountCodesList');
    let input =  $('#verifyDiscountInput');
    let button = $('#verifyDiscountButton');
    if (!discountList[0] || !input[0] || !button[0])
        return;

    let addDiscount = discountList.find('.useDiscount');
    addDiscount.on('click', function(e) {
        let discountCode = e.target.closest('.item').firstElementChild.innerText;
        input.val(discountCode);
        button.trigger('click');
        input.val('');
        e.target.closest('.item').remove();
        if ($('#availableCodes .discountCodesList .item').length === 0)
            $('#availableCodes').remove();
    });
}

function initEbCounter() {
    let counter = $('#ebCounter');
    if (!counter[0])
        return;
    
    updateTimer(counter);
}

function updateTimer(counter = $('#ebCounter')) {
    let timer = getTimer();
    counter.text(timer.hours + ':' + timer.minutes + ':' + timer.seconds);
    setTimeout(updateTimer, 1000);
}

function getTimer() {
    let timeDiff = getTimeDiff();
    let formatted = formatTime(timeDiff);

    return formatted;
}

function getTimeDiff() {
    const now = new Date();

    const morningStart = new Date(now);
    morningStart.setHours(0, 0, 0, 0);

    const morningEnd = new Date(now);
    morningEnd.setHours(10, 0, 0, 0);

    const eveningStart = new Date(now);
    eveningStart.setHours(19, 0, 0, 0);

    const tomorrowMorning = new Date(now);
    tomorrowMorning.setDate(tomorrowMorning.getDate() + 1);
    tomorrowMorning.setHours(10, 0, 0, 0);

    let diff;

    // vóór 10:00 → early bird actief
    if (now < morningEnd) {
        diff = morningEnd - now;
        $('#ebCounter').parent().show();
    }
    // tussen 10:00 en 19:00 → geen early bird, aftellen naar 19:00
    else if (now < eveningStart) {
        diff = eveningStart - now;
        $('#ebCounter').parent().hide();
    }
    // na 19:00 → early bird actief
    else {
        const midnight = new Date(now);
        midnight.setHours(24, 0, 0, 0);
        diff = midnight - now;
        $('#ebCounter').parent().show();
    }

    return diff;
}

function formatTime(timeDiff) {
    const hours = ("0" + Math.floor(timeDiff / (1000 * 60 * 60))).slice(-2);
    const minutes = ("0" + Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60))).slice(-2);
    const seconds = ("0" + Math.floor((timeDiff % (1000 * 60)) / 1000)).slice(-2);

    let formatted = {hours : hours, minutes : minutes, seconds : seconds};
    
    return formatted;
}

function initDiscountInputWatch() {
    let input = $('#verifyDiscountInput');
    if (!input[0])
        return;

    input.on('keydown', function(e) {
        if (e.key !== 'Enter' || input.val() === '')
            return;

        $('#verifyDiscountButton').trigger('click');
    });
}

function initTest() {
    let companyLookupForm = $('.companyLookupForm');
    if (!companyLookupForm[0])
        return;

    $('#lookupButton').trigger('click');

    let fields = ['registration_form_kvknummer', 'registration_form_btwnummer', 'registration_form_company_name', 'registration_form_zipcode', 'registration_form_streetname', 'registration_form_streetnumber', 'registration_form_city', 'registration_form_company_phonenumber', 'registration_form_firstname', 'registration_form_lastname', 'registration_form_email', 'registration_form_contact_phonenumber', 'registration_form_plainPassword', 'registration_form_confirmPassword', 'registration_form_message'];

    $('#submitbutton').trigger('click');
    
    return;
}
